import { render, staticRenderFns } from "./memberReferral.vue?vue&type=template&id=846de6c0&scoped=true&"
import script from "./memberReferral.vue?vue&type=script&lang=js&"
export * from "./memberReferral.vue?vue&type=script&lang=js&"
import style0 from "./memberReferral.vue?vue&type=style&index=0&id=846de6c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "846de6c0",
  null
  
)

export default component.exports